import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiX, FiLock } = FiIcons;

function SecurityBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const securityNoticeShown = localStorage.getItem('securityNoticeShown');
    if (!securityNoticeShown) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('securityNoticeShown', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md bg-blue-900 text-white rounded-2xl shadow-2xl z-50 p-6"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center">
          <div className="bg-blue-800 p-2 rounded-lg mr-3">
            <SafeIcon icon={FiShield} className="text-blue-200" />
          </div>
          <div>
            <h3 className="font-semibold text-lg">🔒 Security Notice</h3>
            <p className="text-blue-200 text-sm">Protected by BertoProduction</p>
          </div>
        </div>
        <button
          onClick={handleAccept}
          className="text-blue-200 hover:text-white transition-colors"
        >
          <SafeIcon icon={FiX} />
        </button>
      </div>

      <div className="space-y-3 text-sm">
        <div className="flex items-center">
          <SafeIcon icon={FiLock} className="text-blue-300 mr-2 flex-shrink-0" />
          <span>All image processing happens locally in your browser</span>
        </div>
        <div className="flex items-center">
          <SafeIcon icon={FiShield} className="text-blue-300 mr-2 flex-shrink-0" />
          <span>No images are uploaded to our servers</span>
        </div>
        <div className="flex items-center">
          <SafeIcon icon={FiLock} className="text-blue-300 mr-2 flex-shrink-0" />
          <span>Your privacy is our priority</span>
        </div>
      </div>

      <button
        onClick={handleAccept}
        className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition-colors font-medium"
      >
        Got it, thanks!
      </button>
    </motion.div>
  );
}

export default SecurityBanner;